import React from 'react';

export default function Buttom(props) {
  const onClick = function (e) {
    e.preventDefault();
    if (props.onClick) props.onClick({name: props.name, value: 'clicked'});
    else console.log(props.name, 'clicked');
  };
  const inputProps = {
    id: props.id || 'button-' + props.name,
    type: props.type || 'button',
    name: props.name,
    value: props.children,
    className: 'btn btn-default',
    onClick,
  };
  return (<input {...inputProps} />);
};



// WEBPACK FOOTER //
// ../hyperdb-utils/src/components/ui-react/Button.jsx